import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';

const ClientSegmentation = () => {
    const data = [
        { no: 112, label: 'Existing CLIENTS', color: '#3071FE' },
        { no: 112, label: 'Active', color: '#03C4A9' },
        { no: 112, label: 'Chum Protection', color: '#FBCA0E' },
        { no: 112, label: 'Defected Clients', color: '#FF5E1B' },
    ];

    return (
        <div style={{ marginBottom: '30px' }}>
            <Typography variant="h4" style={{ marginBottom: '20px' }}>Clients Segmentation</Typography>
            <Grid container spacing={2}>
                {data.map((item, index) => (
                    <Grid item xs={6} md={3} key={index}>
                        <Paper
                            elevation={3}
                            style={{ backgroundColor: item.color, textAlign: 'center', height: '100%', padding: '35px 20px', display: 'flex', alignItems: 'center', flexDirection: 'column', borderRadius: '10px' }}
                        >
                            <Typography variant="h2" style={{ color: '#fff' }}>
                                {item.no}
                            </Typography>
                            <Typography variant="h6" style={{ color: '#fff' }}>
                                {item.label}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default ClientSegmentation;